import { useState, useEffect } from 'react';
import { makeApiCall } from '../redux/actions/common/common-action';

type errorHandle = () => void;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useFetch = (url: string, param?: any, errorHandle?: errorHandle) => {
  const [response, setResponse] = useState([]);
  useEffect(() => {
    async function fetch() {
      try {
        const data = await makeApiCall({
          method: 'get',
          url,
          withCredentials: true,
          param
        });
        setResponse(data.data.data);
      } catch (e) {
        // eslint-disable-next-line no-console
        errorHandle || console.error();
      }
    }
    fetch();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return response;
};
